import cn from 'clsx';
import { Fragment, ReactNode, useRef } from 'react';
import Badge from '@v2/shared/components/Badge';
import { Popover, Transition } from '@headlessui/react';
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  title: string;
  showNewBadge?: boolean;
  className?: string;
  children: ReactNode;
  href?: string;
};

export default function DesktopMenuPopover({ title, showNewBadge, className, children }: Props) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <Popover as="div" className="flex items-center justify-center">
      <Popover.Button
        ref={buttonRef}
        className={cn(
          'relative',
          'inline-flex items-center',
          'px-3 py-2 rounded-md',
          'bg-white hover:bg-slate-100 active:bg-slate-200',
          'text-slate-800 hover:text-slate-900 active:text-slate-950',
          'font-semibold whitespace-nowrap cursor-pointer',
          className
        )}
      >
        <div>
          <span>{title}</span>
          <FontAwesomeIcon icon={faAngleDown} size="xs" className="ml-1" />
        </div>
        {showNewBadge && <Badge className="absolute right-3 bottom-3 text-[11px]">New</Badge>}
      </Popover.Button>
      <Transition
        as={Fragment}
        enter="transition-[grid-template-rows] ease-in-out duration-100"
        enterFrom="grid-rows-[0fr]"
        enterTo="grid-rows-[1fr]"
        leave="transition-[grid-template-rows] ease-in-out duration-200"
        leaveFrom="grid-rows-[1fr]"
        leaveTo="grid-rows-[0fr]"
      >
        <Popover.Panel
          as="div"
          className={cn(
            'fixed inset-x-0 md:top-[126px] xl:top-[82px] bg-white border-b-[1.5px] border-slate-200 z-[260] grid'
          )}
        >
          <div className="overflow-hidden">{children}</div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}
